import {
  LinearProgress,
  Stack,
  Tab,
  Tabs,
  Typography,
  Grid,
  Button,
  ButtonBase,
  Tooltip
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import { removeFromIndexedDB } from "../../../storage/profileStorage";
import React from "react";
import Cardcheckbox from "../../../components/Cardcheckbox";
import InfoIcon from "@mui/icons-material/Info";
import { useSelector, useDispatch } from "react-redux";
import IdentificationRegister  from "../IdentificationRegister ";
import RegisterNotificationData from "../RegisterNotification/RegisterNotificationData";
import { setCurrentTab } from "../slice";
import {
  activityOptions,
  activityRecieverOptions,
  activitySpecialRecieverOptions,
  activityOptionsHibrid,
  entityData,
  entityTypeOptions,
  platformOptions,
  profileOptions,
} from "../../../data";
import logo from "../../../logo.svg";
import { responsiveValue } from "../../../theme/Styles/responsiveValue";
import BackButton from "../../../components/BackButton";
import { EntityType } from "../../../common/enum";
import { logout } from "../../../redux/features/authSlice";
import { clearCart } from "../../DonationView/slice";
import { resetDashBoard } from "../../DashBoardView/slice";

const RegisterHeaderTab = ({ navigate, t }) => {
  const theme = useTheme();
  const allQuestions = [
    profileOptions,
    activityOptions,
    entityTypeOptions,
    entityData,
    platformOptions,
  ];

  const {
    onBoarding: {
      currentTab,
      disableFrom,
      profileOptionsValue,
      activityOptionsValue,
      entityTypeOptionsValue,
    },
  } = useSelector((state) => state);


  const currentQuestion = allQuestions[currentTab];
  const [details, setDetails] = React.useState([]);
  const dispatch = useDispatch();
  const handleChange = (event, newValue) => {
    dispatch(setCurrentTab(Number(newValue)));
  };

  const activitiesOptions = React.useMemo(() => {
    if (profileOptionsValue === EntityType.distributor) {
      return activityRecieverOptions;
    } else if (profileOptionsValue === EntityType.specialDistributor) {
      return activitySpecialRecieverOptions;
    }else if(profileOptionsValue == EntityType.donor){
      return activityOptions;
    }else{
      return activityOptionsHibrid;
    }
    
  }, [profileOptionsValue, EntityType]);

  const buttonStyle = {
    marginTop: "20px",
    justifyContent: "center",
    [theme.breakpoints.up("md")]: {
      ml: 12,
      justifyContent: "flex-start",
    },
    mx: 1,
  };

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(logout());
    dispatch(clearCart());
    dispatch(resetDashBoard());
    // localStorage.removeItem('userData')
    // localStorage.removeItem('entityProfile')
      removeFromIndexedDB("profiles", "entityProfile");
      removeFromIndexedDB("userData", "userData");
      removeFromIndexedDB("entityProfileSelect", "entityProfileSelect");
    navigate("/");
  };

  return (
    <>
      {" "}
      <Box sx={{ width: "100%" }}>
        <TabContext
          value={currentTab.toString()}
          indicatorColor={""}
          onChange={handleChange}
          sx={{
            "& .MuiTabs-flexContainer": {
              flexWrap: "wrap",
            },
          }}
        >
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              bgcolor: "background.paper",
            }}
          >
            <TabList
              sx={{
                display: "flex",
                "& .Mui-selected": {
                  color: " #37773E!important",
                  border: "none",
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: "#FFFFFF",
                },
              }}
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              onChange={handleChange}
              aria-label="lab API tabs example"
            >
              <Box
                sx={{
                  p: 2,
                  [theme.breakpoints.up("md")]: {
                    mx: 12,
                  },
                  mx: 1,
                }}
              >
                <img
                  src={logo}
                  className="App-logo"
                  // style={{ width: '100%' }}
                  alt="Tomaládácá logotipo"
                />
              </Box>
              <Tab value={"0"} label={"0.1 " + t("profile")} />
              <Tab
                value={"1"}
                label={"0.2 " + t("activity")}
                disabled={disableFrom <= 1}
              />
              <Tab
                value={"2"}
                label={"0.3 " + t("entityType")}
                disabled={disableFrom <= 2}
              />
              <Tab
                value={"3"}
                label={"0.4 " + t("entityData")}
                disabled={disableFrom <= 3}
              />
              <Tab
                value={"4"}
                label={"0.5" + " " + t("platform")}
                disabled={disableFrom <= 4}
              />
              <Tab>
                
              </Tab>
            </TabList>
            <Button
              onClick={(e) => handleLogout(e)}
              sx={{
                background: "#FFEEEE",
                color: "#FF0000",
                padding: '8px 22px',
                borderRadius: '4px',
                position:'absolute',
                top:'25px',
                right:'10px',
                "&:hover": { background: "#FF0000", color: "#FFEEEE" },
              }}
            >
              {t("cancel")}
            </Button>
            <LinearProgress
              variant="determinate"
              value={20 * (currentTab + 1)}
            />
          </Box>

          <Box
            sx={{
              maxWidth: "sm",
              [theme.breakpoints.up("md")]: {
                ml: 12,
              },
            }}
          >
            <Typography
              marginLeft={responsiveValue(
                "",
                "",
                "25px",
                "50px",
                "50px",
                "15px"
              )}
              marginTop="50px"
              textAlign={"start"}
              variant="h1"
              component="h1"
              sx={{
                fontSize: responsiveValue(
                  "18px",
                  "",
                  "",
                  "3rem",
                  "3rem",
                  "20px"
                ),
                fontWeight: 400,
              }}
            >
              {t(currentQuestion.question)}{" "}
            </Typography>
          </Box>
          <TabPanel value={"0"}>
          
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                [theme.breakpoints.up("md")]: {
                  ml: 12,
                  justifyContent: "flex-start",
                  width: "90%",
                },
                mx: 1,
              }}
            >
              {profileOptions.options?.map((item, index) => (
                
                <React.Fragment key={item.title}>
                  
                  <Cardcheckbox
                    // setBlock={setBlock}
                    block={currentTab}
                    icon={item.img}
                    isChecked={item.value === profileOptionsValue}
                    title={t(item.title)}
                    subtitle={t(item.body)}
                    type="profile"
                    setDetails={setDetails}
                    details={details}
                    property={currentQuestion.property}
                    value={item.value}
                    width={
                      item.value === EntityType.specialDistributor
                        ? "200"
                        : "200"
                    }
                    height={
                      item.value === EntityType.specialDistributor ? "" : ""
                    }
                  />
                </React.Fragment>
              ))}
            </Box>
          </TabPanel>
          <TabPanel value={"1"}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                [theme.breakpoints.up("md")]: {
                  ml: 12,
                  justifyContent: "flex-start",
                },
                mx: 1,
              }}
            >
              {activitiesOptions.options?.map((item, index) => (
                <Cardcheckbox
                  key={item.title}
                  block={currentTab}
                  icon={item.img}
                  title={t(item.title)}
                  isChecked={item.value === activityOptionsValue}
                  type="activity"
                  setDetails={setDetails}
                  details={details}
                  property={currentQuestion.property}
                  value={item.value}
                  width={"200"}
                  height={"200"}
                />
              ))}
            </Box>
            <BackButton style={buttonStyle} />
          </TabPanel>
          <TabPanel value={"2"}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                [theme.breakpoints.up("md")]: {
                  ml: 12,
                  justifyContent: "flex-start",
                },
                mx: 1,
              }}
            >
              {entityTypeOptions.options?.map((item, index) => (
                <Cardcheckbox
                  key={item.title}
                  // setBlock={setBlock}
                  block={currentTab}
                  icon={item.img}
                  title={t(item.title)}
                  isChecked={item.value === entityTypeOptionsValue}
                  type="entityType"
                  setDetails={setDetails}
                  details={details}
                  property={currentQuestion.property}
                  value={item.value}
                  width={"200"}
                  height={"200"}
                />
              ))}
            </Box>
            <BackButton style={buttonStyle} />
          </TabPanel>
          <TabPanel value={"3"}>
            <IdentificationRegister 
              details={details}
              setDetails={setDetails}
              block={currentTab}
              t={t}
            />
          </TabPanel>
          <TabPanel value={"4"}>
            <RegisterNotificationData currentQuestion={platformOptions} t={t} />
          </TabPanel>
        </TabContext>
      </Box>
    </>
  );
};

export default RegisterHeaderTab;
